import { apiClient } from "@/lib/api/client";
import { buildQueryString } from "@/lib/utils/query-string";
import type { GlobalSearchResponse } from "../types/search.types";

const BASE = "/api/search/";

export async function globalSearch(
  q: string,
  limit = 5
): Promise<GlobalSearchResponse> {
  const { data } = await apiClient.get<GlobalSearchResponse>(
    `${BASE}?${buildQueryString({ q, limit })}`
  );
  return data;
}
